// extracted by mini-css-extract-plugin
export var black = "_40-6";
export var brand = "_40-1";
export var ddefault = "_40-0";
export var error = "_40-3";
export var gray = "_40-2";
export var highContrast = "_40-8";
export var outline = "_40-7";
export var success = "_40-5";
export var warning = "_40-4";